module.exports = __webpack_public_path__ + "static/img/s404.3e05c54.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/productSpring/images/s404.png
// module id = 556
// module chunks = 3